import { IContextualMenuItemProps, Icon } from '@fluentui/react';

export const TwoLineMenuItem: React.FunctionComponent<
  IContextualMenuItemProps
> = (props) => {
  const { item, classNames, hasIcons } = props;

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      {hasIcons && item.iconProps && (
        <Icon {...item.iconProps} className={classNames.icon} />
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          flexGrow: 1,
          minWidth: 0,
          margin: '0 4px',
          padding: '4px 0',
          lineHeight: 1.3,
          textAlign: 'left',
        }}
      >
        <span>{item.text}</span>
        {item.secondaryText && (
          <span style={{ fontSize: 11, opacity: 0.6 }}>
            {item.secondaryText}
          </span>
        )}
      </div>

      {item.subMenuProps && (
        <Icon iconName="ChevronRight" className={classNames.subMenuIcon} />
      )}
    </div>
  );
};
